export default __webpack_public_path__ + "static/media/whitelist-icon.c24008ab.png";